const fetchPropertyNoteById = (id, notesArray = []) => {
  const propertyNote = notesArray.find(item => (item.id === id));
  return (propertyNote) ? propertyNote.note.trim() : '';
};

export default fetchPropertyNoteById;
